import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import ButtonText from '@segment/matcha/components/ButtonText'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import BestStackImage from './BestStackImage'

const copy = {
  overline: `Segment for Product Teams`,
  heading: `Launch with the right stack`,
  description: `Enable the best product analytics tools, A/B testing tools, and data warehousing tools with the flip of a switch.`,
}

const link = {
  text: `Explore Connections`,
  url: `https://segment.com/docs/connections/sources/`,
}

const BestStack: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="2Col" reverse={true} copyVariant="narrow">
        <Section.Contents>
          <BestStackImage />
        </Section.Contents>
        <StyledSectionCopy>
          <CopyTextBase>
            <CopyText.Overline>{copy.overline}</CopyText.Overline>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
            <LinkWrapper size="medium" tag="a" href={link.url} iconEnd={ChevronRightIcon}>
              {link.text}
            </LinkWrapper>
          </CopyTextBase>
        </StyledSectionCopy>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.section``

const StyledSectionBase = styled(SectionBase)`
  overflow: visible;
`

const StyledSectionCopy = styled(Section.Copy)`
  align-self: center;
  direction: initial;
  justify-self: end;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 440px;
  }
`

const LinkWrapper = styled(ButtonText)`
  padding-top: 0;
`

export default BestStack
